import { Outlet, NavLink, useNavigate } from "react-router-dom";
import styles from "./index.module.css";
import NavDropdown from "../../elements/NavDropdown";
import { useDispatch } from "react-redux";
import {
  toggleMultiSelectDropdown,
  toggleNormalDropdown,
  toggleCalendar,
} from "../../../store/slices/dropdown/toggle.slice";
import { useSelector } from "react-redux";
import {
  fetchAllBrandAsyncThunk,
  fetchAllLocationAsyncThunk,
  fetchAllSubCategoryAsyncThunk,
  fetchDateRangeAsyncThunk,
  setBrandData,
  setDataRange,
  setLocationData,
  setSource,
  setSubCategoryData,
} from "../../../store/slices/constants/constant.slice";
import { useEffect } from "react";
import {
  fetchFnbStore,
  fetchFnbTerminal,
} from "../../../store/slices/fnb/constants.slice";
import { getSource } from "../../../utils/helpers";
import { setOrganizationId, clearUserData } from "../../../store/slices/user/user.slice";
import { clearWatchlistData } from "../../../store/slices/watchlist/data.slice";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const multiSelDrop = useSelector(
    (store) => store.toggleDropdown.multiSelectDropdown
  );
  const normalDrop = useSelector((store) => store.toggleDropdown.dropdown);

  const calendar = useSelector((store) => store.toggleDropdown.calendar);

  const onLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("data");
    dispatch(clearUserData());
    dispatch(clearWatchlistData());
    navigate("/");
  };
  const source = useSelector((store) => store.constant.source);
  const organizationId = useSelector((store) => store.user.organizationId);

  const toggleDropdowns = () => {
    dispatch(toggleMultiSelectDropdown({ val: !multiSelDrop }));
    dispatch(toggleNormalDropdown({ val: !normalDrop }));
    dispatch(toggleCalendar({ val: !calendar }));
  };

  async function getConstants() {
    try {
      const brand = await dispatch(fetchAllBrandAsyncThunk({ source }));

      const sub_category = await dispatch(
        fetchAllSubCategoryAsyncThunk({
          source,
        })
      );
      const dateRange = await dispatch(fetchDateRangeAsyncThunk());
      await dispatch(fetchFnbStore());
      await dispatch(fetchFnbTerminal());

      if (brand.payload && brand.payload.status === "success") {
        dispatch(setBrandData(brand.payload.data));
      }
      if (sub_category.payload && sub_category.payload.status === "success") {
        dispatch(setSubCategoryData(sub_category.payload.data));
      }
      if (dateRange.payload && dateRange.payload.status === "success") {
        dispatch(setDataRange(dateRange.payload.data[0]));
      }
    } catch (error) {
      console.error("Error in getConstants:", error);
    }
  }
  useEffect(() => {
    dispatch(fetchAllLocationAsyncThunk({source}));
  }, [source]);
  useEffect(() => {
    getConstants();
  }, [source]);
  
  // Load organization_id from localStorage on component mount
  useEffect(() => {
    const userData = localStorage.getItem("data");
    if (userData) {
      try {
        const parsedData = JSON.parse(userData);
        if (parsedData.organisation_id && !organizationId) {
          dispatch(setOrganizationId(parsedData.organisation_id));
        }
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
      }
    }
  }, [dispatch, organizationId]);

  return (
    <div className={styles["container"]}>
      <div className={styles["sidebar"]}>
        <div className={styles["top"]}>
          <div className={styles["logo"]}>
            <img src="/new_logo.png" alt="white logo" />
          </div>
        </div>
        <div className={styles["middle"]}>
          <div className={styles["navigation"]}>
            {source === "aelia_auckland" && (organizationId === 1 || organizationId === 2) && (
              <NavDropdown title="F&B" icon="bi-chevron-down" default={true}>
                <NavLink
                  to="/dashboard/fnb-dashboard"
                  className={({ isActive }) =>
                    `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                  }
                >
                  <div>
                    <i className="bi bi-clipboard-data"></i>
                  </div>
                  <div>Dashboard</div>
                </NavLink>
                <NavLink
                  to="/dashboard/fnb-products"
                  className={({ isActive }) =>
                    `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                  }
                >
                  <div>
                    <i className="bi bi-window-sidebar"></i>
                  </div>
                  <div>Products</div>
                </NavLink>
                <NavLink
                  to="/dashboard/fnb-reporting"
                  className={({ isActive }) =>
                    `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                  }
                >
                  <div>
                    <i className="bi bi-file-earmark-spreadsheet"></i>
                  </div>
                  <div>Reporting</div>
                </NavLink>
              </NavDropdown>
            )}

            <NavDropdown
              title="Duty-Free"
              icon="bi-chevron-down"
              default={true}
            >
              <NavLink
                to="/dashboard/df-dashboard"
                className={({ isActive }) =>
                  `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                }
              >
                <div>
                  <i className="bi bi-clipboard-data"></i>
                </div>
                <div>Dashboard</div>
              </NavLink>
              <NavLink
                to="/dashboard/df-products"
                className={({ isActive }) =>
                  `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                }
              >
                <div>
                  <i className="bi bi-window-sidebar"></i>
                </div>
                <div>Products</div>
              </NavLink>
              <NavLink
                to="/dashboard/df-ai-summary"
                className={({ isActive }) =>
                  `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                }
              >
                <div>
                  <i className="bi bi-stars"></i>
                </div>
                <div>AI Summary</div>
              </NavLink>
              <NavLink
                to="/dashboard/df-watchlist"
                className={({ isActive }) =>
                  `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                }
              >
                <div>
                  <i class="bi bi-bookmark-check"></i>
                </div>
                <div>Watchlist</div>
              </NavLink>

              {organizationId === 3 && (
                <NavLink
                  to="/dashboard/chivas-dior"
                  className={({ isActive }) =>
                    `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                  }
                >
                  <div>
                    <i class="bi bi-bag"></i>
                  </div>
                  <div>Chanel and Dior</div>
                </NavLink>
              )}

              <NavLink
                to="/dashboard/analytics"
                className={({ isActive }) =>
                  `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                }
              >
                <div>
                  <i class="bi bi-pie-chart"></i>
                </div>
                <div>Analytics</div>
              </NavLink>
              <NavLink
                to="/dashboard/reporting"
                className={({ isActive }) =>
                  `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                }
              >
                <div>
                  <i class="bi bi-file-earmark-spreadsheet"></i>
                </div>
                <div>Reporting</div>
              </NavLink>
              <NavLink
                to="/dashboard/live-monitoring"
                className={({ isActive }) =>
                  `${styles["nav_item"]} ${isActive ? styles["active"] : ""}`
                }
              >
                <div>
                  <i class="bi bi-graph-up-arrow"></i>
                </div>
                <div>Live Monitoring</div>
              </NavLink>
            </NavDropdown>
          </div>
        </div>
        <div className={styles["bottom"]}>
          <div className={styles["logout"]} onClick={onLogout}>
            <div>
              <i className="bi bi-patch-minus"></i>
            </div>
            <div>Logout</div>
          </div>
        </div>
      </div>
      <div className={styles["main"]} onClick={toggleDropdowns}>
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
